import styled from 'styled-components';

export const Section = styled.div`
  .analysis-loading .ai-loading-message {
    font-size: 16px;
    font-weight: 600;
  }

  .stats-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));
    gap: 12px;
  }

  .points-card {
    border-radius: 8px;
  }

  .points-title {
    font-size: 16px;

    .material-icons,
    .material-icons-outlined {
      font-size: 20px;
    }
  }

  .points-list {
    font-size: 14px;
    color: ${(props) => props.theme.$gray900};

    li {
      margin-bottom: 4px;
    }
  }
`;
